const imports = [
    { selector: "#applications", module: () => require('../applications/list/list.js') },
    { selector: "#tender_items", module: () => require('../tenders/list/list.js') },
];

imports.forEach(item => {
    if ($(item.selector).length > 0) {
        item.module();
    }
});
